import { Box, Text } from '@chakra-ui/react'

interface Props {
  visible: boolean
}

export function GameResetOverlay({ visible }: Props) {
  if (!visible) return null

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      w="100%"
      h="100%"
      bg="rgba(0,0,0,0.7)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={20}
    >
      <Text fontSize="3xl" fontWeight="bold" color="white">
        Game Reset!
      </Text>
    </Box>
  )
} 